// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__rTxcP","header":"PatientQuestionnaire_header__MH2fc","info":"PatientQuestionnaire_info__1ompJ"};